import React from "react";
export class ChartLoader extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton plk-skeleton-block",
      style: {
        height: '300px'
      }
    });
  }
}
class LoaderDisplay extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-loader-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton",
      style: {
        padding: '24px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '40%',
        height: '18px',
        marginBottom: '24px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        gap: '16px',
        marginBottom: '32px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '80px',
        flex: 1
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '80px',
        flex: 1
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '80px',
        flex: 1
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '80px',
        flex: 1
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '300px',
        marginBottom: '24px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '30%',
        height: '14px',
        marginBottom: '16px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '100%',
        height: '12px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '100%',
        height: '12px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '100%',
        height: '12px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '100%',
        height: '12px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '100%',
        height: '12px'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-line",
      style: {
        width: '80%',
        height: '12px'
      }
    })));
  }
}
export class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.timeoutId = null;
    this.unmounted = false;
    this.state = {
      show: false
    };
  }
  componentDidMount() {
    var delay = this.props.delay;
    if (!delay) delay = 300;else {
      delay = parseInt(delay);
    }
    this.timeoutId = setTimeout(() => {
      if (!this.unmounted) {
        this.setState({
          show: true
        });
      }
    }, delay);
  }
  componentWillUnmount() {
    this.unmounted = true;
    if (!this.state.show) {
      clearTimeout(this.timeoutId);
    }
  }
  render() {
    if (!this.state.show) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(LoaderDisplay, null);
    }
  }
}
export class EllipsisLoader extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    var cls = 'loader-container';
    if (this.props.cls) cls = this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton",
      style: {
        padding: '16px',
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-skeleton-block",
      style: {
        height: '200px'
      }
    })));
  }
}
export default {
  ChartLoader,
  Loader,
  EllipsisLoader
};